export default {
	attributes: {
		design: 'basic',
		columns: 2,
		numberOfItems: 2,
		order: 'desc',
		orderBy: 'date',
		postType: 'post',
		taxonomyType: 'category',
		taxonomyFilterType: '__in',
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showImage: true,
		showCategory: true,
		categoryLineHeightUnit: 'em',
		categoryTabletLineHeightUnit: 'em',
		categoryMobileLineHeightUnit: 'em',
		categoryHighlighted: false,
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		showExcerpt: true,
		excerptLineHeightUnit: 'em',
		excerptTabletLineHeightUnit: 'em',
		excerptMobileLineHeightUnit: 'em',
		showMeta: true,
		showAuthor: false,
		showDate: true,
		showComments: false,
		metaLineHeightUnit: 'em',
		metaTabletLineHeightUnit: 'em',
		metaMobileLineHeightUnit: 'em',
		showReadmore: true,
		readmoreLineHeightUnit: 'em',
		readmoreTabletLineHeightUnit: 'em',
		readmoreMobileLineHeightUnit: 'em',
		showLoadMoreButton: false,
		loadMoreButtonLineHeightUnit: 'em',
		loadMoreButtonTabletLineHeightUnit: 'em',
		loadMoreButtonMobileLineHeightUnit: 'em',
		loadMoreButtonText: 'Load More',
		uniqueClass: 'ugb-6b45c1f',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
